import { parseISO } from "date-fns";
import { HistoricalDataItemGroup, HistoricalDataItem } from "../../services/historicalData";
import { addAlpha } from "../../utils/colorUtils";
import { TChartItem } from "./types";

// calculate the average of a dataset
export function average(ctx) {
  const values = ctx.chart.data.datasets[0]?.data;
  if (!values)
    return 0;
  return values.reduce((a, b) => {
    return a + b.y;
  }
    , 0) / values.length;
}

// sort chart items by time
export function sortByTime(a, b) { return b.x - a.x }

// calc a gradient for line chart lines
export function getGradient(ctx: any, chartArea: any, color: string) {
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  gradient.addColorStop(1, addAlpha(color, 0.4));
  gradient.addColorStop(0.1, addAlpha(color, 0.0));
  return gradient;
}

export function mapHistoryItemsToChartItems(data: HistoricalDataItem[], start: Date, end: Date, currentValue: number | boolean, noCurrent?: boolean): TChartItem[] {
  //const now = new Date();
  //const myEnd = end;// > now ? now : end
  const arr2 = data.map((item: HistoricalDataItem) => {
    return { x: parseISO(item.timeStamp), y: item.value }
  });
  if (arr2.length <= 1) {
    arr2.push({ x: end, y: currentValue })
    arr2.unshift({ x: start, y: currentValue })
  }
  else if (arr2.length >= 2) {
    const first = arr2[0];
    if (!noCurrent) {
      arr2.push({ x: end, y: currentValue })
    }
    var firstDate = new Date(first.x.toString());
    arr2.unshift({ x: start.getTime() < firstDate.getTime() ? start : first.x, y: first.y })
  }
  return arr2;

}

export function mapHistoryGroupItemsToChartItems(data: HistoricalDataItemGroup[], start: Date, end: Date, currentValue: number | boolean, selectValue?: (elm: HistoricalDataItemGroup) => any): TChartItem[] {
  //const now = new Date();
  const myEnd = end;//end > now ? now : end
  const arr2: TChartItem[] = data.map((item: HistoricalDataItemGroup) => {
    return { x: parseISO(item.timeStamp), y: selectValue ? selectValue(item) : item.avgValue }
  });

  if (arr2.length <= 1) {
    arr2.push({ x: myEnd, y: currentValue })
    arr2.unshift({ x: start, y: currentValue })
  }
  else if (arr2.length >= 2) {
    const first = arr2[0];
    arr2.push({ x: myEnd, y: currentValue })    
    var firstDate = new Date(first.x.toString());
    arr2.unshift({ x: start.getTime() < firstDate.getTime() ? start : first.x, y: first.y })
  }
  return arr2;

}

